import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoThumbsDown = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>ThumbsDown</title>
    <path
      d="M5.45 16.277c-.299.244-1.036 1.118-.864 2.286.173 1.168 1.143 1.714 2.286 1.714l6.339.045c-1.182 6.858.72 9.492 2.799 8.127.988-.649 1.03-1.886 1.621-4.743.473-2.286 2.168-4.381 2.956-5.143h2.272a2.286 2.286 0 0 0 2.286-2.286v-5.876a2.286 2.286 0 0 0-2.118-2.28l-3.596-.265c-.197-.571-2.122-1.126-5.656-1.126h-5.01c-1.633.122-2.547 1.616-1.774 2.858m-1.541 6.69c-.71-.802-.765-2.37.319-3.43m-.319 3.43h.813m-.494-3.43c-.655-1.385-.018-2.599 1.222-3.26m-1.222 3.26h.494m.728-3.26h.284"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoThumbsDown;
